import React, { FC } from "react";
import type { AutomationChallengesProps } from "@/types";
import { Cta } from "../cta";
import { TextCols } from "../text-cols";

export const AutomationChallenges: FC<AutomationChallengesProps> = ({
  content,
  cta,
}) => {
  return (
    <section className="automationChallenges">
      <div className="wrapper">
        <TextCols content={content} maxTitleWidth={766} />
      </div>
      {/* TODO: Temporary hidden */}
      {/* <div className="wrapper wrapper_lg">
        <Cta cta={cta} className="automationChallenges--cta" />
      </div> */}
    </section>
  );
};
